import { render, staticRenderFns } from "./CreateSGScripts.vue?vue&type=template&id=64cf94be"
import script from "./CreateSGScripts.vue?vue&type=script&lang=js"
export * from "./CreateSGScripts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports